import { registerCollisionAnimation } from './CollisionAnimationRegistry';

registerCollisionAnimation('PLASMA_BLOB', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  ctx.fillStyle = determineColor(0, 1);
  ctx.globalAlpha = (1 - progress) * 0.6;
  ctx.beginPath();
  for (let a = 0; a <= Math.PI * 2; a += 0.2) {
    const r = e.radius * 2 + Math.sin(a * 5 + elapsed * 0.01) * 20 * (1 - progress);
    const x = e.pos.x + Math.cos(a) * r;
    const y = e.pos.y + Math.sin(a) * r;
    ctx.lineTo(x, y);
  }
  ctx.fill();
});
